var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_vm._t("default"),_vm._v(" "),_c('error-response',{attrs:{"error":_vm.error},on:{"delete":function($event){_vm.error=null}}}),_vm._v(" "),_c('alert',{ref:"alert"}),_vm._v(" "),_c('portal-target',{attrs:{"name":"modal"}}),_vm._v(" "),_c('portal-target',{attrs:{"name":"dialog"}}),_vm._v(" "),_c('portal-target',{attrs:{"name":"error"}})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }